import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=1ca9f462&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=1ca9f462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9f462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca9f462')) {
      api.createRecord('1ca9f462', component.options)
    } else {
      api.reload('1ca9f462', component.options)
    }
    module.hot.accept("./ProjectForm.vue?vue&type=template&id=1ca9f462&scoped=true&", function () {
      api.rerender('1ca9f462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projects/ProjectForm.vue"
export default component.exports